/** URL gốc backend (không kèm /api/v1). */
export const API_ORIGIN =
  (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ||
  (typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:4520'
    : 'https://api.app.ecdp.vn')

export const API_BASE = `${API_ORIGIN}/api/v1`

export const TOKEN_KEY = 'ecdp_token'
export const REFRESH_KEY = 'ecdp_refresh'
